$(function () {
  $tooltipIcon = $('#rolex-model-suggestion-price-tooltip-icon');
  $tooltip = $('#rolex-model-suggestion-price-tooltip');

  $tooltipIcon.on('mouseenter', function() {
    $tooltip.show();
  });

  $tooltipIcon.on('mouseleave', function() {
    $tooltip.hide();
  });

  // $availabilityIcon = $('#rolex-model-availability-tooltip-icon');
  // $availability = $('#rolex-model-availability-tooltip');

  // $availabilityIcon.on('mouseenter', function() {
  //   $availability.show();
  // });

  // $availabilityIcon.on('mouseleave', function() {
  //   $availability.hide();
  // });
});
